import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4a98606d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "PlanningRecord" }
const _hoisted_2 = { class: "flex items-center" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header__circle" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-draw-polygon fa-lg" })
], -1))
const _hoisted_4 = { class: "ml-3" }
const _hoisted_5 = { class: "text-2xl font-semibold" }
const _hoisted_6 = { class: "text-sm font-medium" }
const _hoisted_7 = { class: "PlanningRecord__content" }
const _hoisted_8 = { class: "grid grid-cols-4 flex-start" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content__placeholder" }, "Кол-во накладных", -1))
const _hoisted_10 = { class: "content__value" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content__placeholder" }, "Кол-во стопов", -1))
const _hoisted_12 = { class: "content__value" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content__placeholder" }, "Физ вес", -1))
const _hoisted_14 = { class: "content__value" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content__placeholder" }, "Объемный вес", -1))
const _hoisted_16 = { class: "content__value" }
const _hoisted_17 = {
  key: 0,
  class: "PlanningRecord__invoices"
}
const _hoisted_18 = { class: "invoices__table" }
const _hoisted_19 = {
  key: 0,
  class: "invoices__actions"
}
const _hoisted_20 = { class: "flex items-center" }
const _hoisted_21 = { class: "actions__count" }
const _hoisted_22 = { class: "flex items-center" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash" }, null, -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-pen" }, null, -1))
const _hoisted_25 = { class: "relative flex items-center justify-end" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-ellipsis-h fa-rotate-90" }, null, -1))
const _hoisted_27 = { class: "relative flex items-center justify-end" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-ellipsis-h fa-rotate-90" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_new_checkbox = _resolveComponent("new-checkbox")!
  const _component_new_button = _resolveComponent("new-button")!
  const _component_record_invoice_row = _resolveComponent("record-invoice-row")!
  const _component_record_container_row = _resolveComponent("record-container-row")!
  const _component_record_container_invoice_row = _resolveComponent("record-container-invoice-row")!
  const _component_new_table_action = _resolveComponent("new-table-action")!
  const _component_new_table_actions = _resolveComponent("new-table-actions")!
  const _component_new_table = _resolveComponent("new-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "PlanningRecord__header",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleInvoices && _ctx.toggleInvoices(...args)))
    }, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.title), 1),
          _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.formatDateFromBackend(_ctx.record.date)), 1)
        ])
      ]),
      _createElementVNode("i", {
        class: _normalizeClass(["fas fa-chevron-down transition-all mr-2", { 'fa-rotate-180': _ctx.state.is_invoices_opened }])
      }, null, 2)
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", null, [
          _hoisted_9,
          _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.record.invoicesCount), 1)
        ]),
        _createElementVNode("div", null, [
          _hoisted_11,
          _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.record.stopsCount), 1)
        ]),
        _createElementVNode("div", null, [
          _hoisted_13,
          _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.record.weight) + " кг", 1)
        ]),
        _createElementVNode("div", null, [
          _hoisted_15,
          _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.record.volumeWeight) + " кг", 1)
        ])
      ])
    ]),
    (_ctx.state.is_invoices_opened)
      ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
          _createElementVNode("div", _hoisted_18, [
            (_ctx.selectedItemsCount > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                  _createElementVNode("div", _hoisted_20, [
                    _createVNode(_component_new_checkbox, {
                      class: "checkbox--table",
                      value: true,
                      onChange: _ctx.unselectAllItems
                    }, null, 8, ["onChange"]),
                    _createElementVNode("div", _hoisted_21, "Выбрано: " + _toDisplayString(_ctx.selectedItemsCount), 1)
                  ]),
                  _createElementVNode("div", _hoisted_22, [
                    (_ctx.isDeleteInvoices)
                      ? (_openBlock(), _createBlock(_component_new_button, {
                          key: 0,
                          class: "NewButton--small NewButton--red mr-2",
                          onClick: _ctx.deleteInvoices
                        }, {
                          default: _withCtx(() => [
                            _hoisted_23
                          ]),
                          _: 1
                        }, 8, ["onClick"]))
                      : _createCommentVNode("", true),
                    (_ctx.state.selected_invoices.length)
                      ? (_openBlock(), _createBlock(_component_new_button, {
                          key: 1,
                          class: "NewButton--small NewButton--white mr-2",
                          onClick: _ctx.setInvoicesWave
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Переместить в волну ")
                          ]),
                          _: 1
                        }, 8, ["onClick"]))
                      : _createCommentVNode("", true),
                    (_ctx.state.selected_invoices.length)
                      ? (_openBlock(), _createBlock(_component_new_button, {
                          key: 2,
                          class: "NewButton--small NewButton--white mr-2",
                          onClick: _ctx.moveInvoiceToContainer
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Переместить в контейнер ")
                          ]),
                          _: 1
                        }, 8, ["onClick"]))
                      : _createCommentVNode("", true),
                    (!_ctx.isHold)
                      ? (_openBlock(), _createBlock(_component_new_button, {
                          key: 3,
                          class: "NewButton--small NewButton--white",
                          onClick: _ctx.assignContainersToCourier
                        }, {
                          "icon-left": _withCtx(() => [
                            _hoisted_24
                          ]),
                          default: _withCtx(() => [
                            _createTextVNode(" Назначить на курьера ")
                          ]),
                          _: 1
                        }, 8, ["onClick"]))
                      : _createCommentVNode("", true),
                    _createElementVNode("i", {
                      class: "fas fa-times ml-5 cursor-pointer",
                      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.unselectAllItems && _ctx.unselectAllItems(...args)))
                    })
                  ])
                ]))
              : _createCommentVNode("", true),
            _createVNode(_component_new_table, {
              class: "NewTable--small",
              "has-checkbox-column": "",
              "has-index-column": "",
              columns: _ctx.columns,
              rows: _ctx.record.invoices,
              "nested-rows": _ctx.record.containers,
              "expanded-rows": _ctx.state.expanded_containers,
              "selected-rows": _ctx.state.selected_invoices,
              "selected-nested": _ctx.state.selected_containers,
              "nested-rows-expand-key": "invoices",
              "clickable-nested": "",
              "clickable-row": "",
              "is-checkbox-disabled": Boolean(_ctx.state.selected_containers.length),
              onSelectAll: _ctx.selectAllItems,
              onSelectRow: _ctx.onSelectInvoice,
              onUnselectRow: _ctx.onUnselectInvoice,
              onSelectNested: _ctx.onSelectContainer,
              onUnselectNested: _ctx.onUnselectContainer,
              onClickNested: _ctx.onRowClicked,
              onClickRow: _ctx.onRowClicked
            }, {
              td: _withCtx(({ column, row }) => [
                _createVNode(_component_record_invoice_row, {
                  column: column,
                  row: row
                }, null, 8, ["column", "row"])
              ]),
              "nested-td": _withCtx(({ column, row, rowindex }) => [
                _createVNode(_component_record_container_row, {
                  index: rowindex,
                  column: column,
                  row: row,
                  expanded: _ctx.isContainerExpanded(row.id),
                  providers: _ctx.providers,
                  onToggle: _ctx.toggleContainer
                }, null, 8, ["index", "column", "row", "expanded", "providers", "onToggle"])
              ]),
              "nested-row-td": _withCtx(({ column, row }) => [
                _createVNode(_component_record_container_invoice_row, {
                  column: column,
                  row: row
                }, null, 8, ["column", "row"])
              ]),
              "nested-row-table-index": _withCtx(() => []),
              "row-actions": _withCtx(({ row }) => [
                _createElementVNode("div", _hoisted_25, [
                  _createVNode(_component_new_button, { class: "NewButton--secondary NewButton--small" }, {
                    popup: _withCtx(() => [
                      _createVNode(_component_new_table_actions, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_new_table_action, {
                            onClick: ($event: any) => (_ctx.moveInvoiceToContainer(row))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" Переместить в контейнер ")
                            ]),
                            _: 2
                          }, 1032, ["onClick"])
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    default: _withCtx(() => [
                      _hoisted_26
                    ]),
                    _: 2
                  }, 1024)
                ])
              ]),
              "nested-row-actions": _withCtx(({ row, parentrow }) => [
                _createElementVNode("div", _hoisted_27, [
                  _createVNode(_component_new_button, { class: "NewButton--secondary NewButton--small" }, {
                    popup: _withCtx(() => [
                      _createVNode(_component_new_table_actions, { class: "many" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_new_table_action, {
                            onClick: ($event: any) => (_ctx.moveInvoiceToContainer(row))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" Переместить в контейнер ")
                            ]),
                            _: 2
                          }, 1032, ["onClick"]),
                          _createVNode(_component_new_table_action, {
                            onClick: ($event: any) => (_ctx.deleteInvoices(parentrow.id, row.id)),
                            class: "red"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" Удалить из контейнера ")
                            ]),
                            _: 2
                          }, 1032, ["onClick"])
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    default: _withCtx(() => [
                      _hoisted_28
                    ]),
                    _: 2
                  }, 1024)
                ])
              ]),
              _: 1
            }, 8, ["columns", "rows", "nested-rows", "expanded-rows", "selected-rows", "selected-nested", "is-checkbox-disabled", "onSelectAll", "onSelectRow", "onUnselectRow", "onSelectNested", "onUnselectNested", "onClickNested", "onClickRow"])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}